import { Component, OnInit } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { CustomDatepickerI18n, DateFormatService, I18n } from './services/date-format.service';
import { PushNotificationMiddlewareServicesService } from './services/push-notification-middleware.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: DateFormatService }
  ]
})
export class AppComponent implements OnInit {
  title = 'frontend';
  constructor(private notifService: PushNotificationMiddlewareServicesService){}

  ngOnInit(): void {
    this.notifService.init();
  }
}
